import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getAdminTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partnership_program: {
        articles: {
          header: 'HEADER',
          create_article: 'CREATE',
          languages: {
            all: 'ALL_LANGUAGES',
          },
          modal_window: {
            title: 'MODAL_TITLE',
            question: 'MODAL_QUESTION',
            delete: 'MODAL_DELETE',
            cancel: 'MODAL_CANCEL',
          },
          view: {
            last_update: 'LAST_UPDATE',
            back: 'VIEW_BACK',
          },
          settings: {
            header_edit: 'HEADER_EDIT',
            header_create: 'HEADER_CREATE',
            back: 'FORM_BACK',
            save: 'FORM_SAVE',
            form: {
              for_language: 'FORM_FOR_LANGUAGE',
              title: 'FORM_TITLE',
              body: 'FORM_BODY',
            },
          },
        },
      },
    },
  }));
}

export function getAffiliateTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    affiliate: {
      articles: {
        header: 'HEADER',
        view: {
          last_update: 'LAST_UPDATE',
          back: 'VIEW_BACK',
        },
      },
    },
  }));
}
